import api from "./client";
import axios from "axios";
import type { BatchUploadResponse, PresignedUrlResponse } from "@/types/api";

/** 단일 presigned URL 발급 */
export const getPresignedUrl = (
  fileName: string,
  mimeType: string,
  fileSize: number,
  photoCategory?: "bride" | "groom",
): Promise<PresignedUrlResponse> =>
  api
    .post("/v1/uploads/presigned-url", { fileName, mimeType, fileSize, photoCategory })
    .then((res) => res.data.data);

/** 배치 presigned URL 발급 */
export const getBatchPresignedUrls = (
  files: { fileName: string; mimeType: string; fileSize: number; photoCategory?: "bride" | "groom" }[],
): Promise<BatchUploadResponse> =>
  api.post("/v1/uploads/batch", { files }).then((res) => res.data.data);

/** S3에 직접 업로드 (presigned URL → PUT) */
export const uploadToS3 = (presignedUrl: string, file: File): Promise<void> =>
  axios
    .put(presignedUrl, file, {
      headers: { "Content-Type": file.type },
    })
    .then(() => undefined);

/** 업로드 완료 확인 */
export const completeUploads = (
  uploadIdxs: number[],
): Promise<{ confirmedCount: number }> =>
  api
    .post("/v1/uploads/complete", { uploadIdxs })
    .then((res) => res.data.data);
